import isNil from "lodash/isNil";
import omitBy from "lodash/omitBy";
import api from "PFCore/api";
import { ChatMessage } from "PFCore/types/chat_message";
import { Id } from "PFTypes/id";

export type FetchMessagesPayload = {
  conversationId?: Id;
  targetId?: string;
  targetType?: string;
  page?: number;
  perPage?: number;
};

export type FetchMessagesResponse = {
  entries: ChatMessage[];
  meta: { total: number };
};

export const fetchMessages = ({
  conversationId,
  targetId,
  targetType,
  page = 1,
  perPage = 10
}: FetchMessagesPayload = {}): Promise<FetchMessagesResponse> =>
  api({
    url: "chat/messages",
    params: omitBy(
      {
        conversationId,
        targetId,
        targetType,
        page,
        perPage
      },
      isNil
    )
  });
